import { styled } from '@mui/system';
import { Box, TableRow, Chip } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  ...theme.typography.bodyRegular,
  color: theme.colors.intenseRed,
  borderColor: theme.colors.intenseRed,
  width: '80px',
}));

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'selected',
})(({ theme, selected }) => ({
  backgroundColor: selected ? theme.palette.background.lightHover : theme.palette.background.hover,
  borderBottom: `1px solid ${theme.colors.borderBottom}`,
  cursor: 'pointer',
  '&:hover': {
    background: theme.palette.background.lightHover,
  },
}));
